import { origin, history } from '../utils/config'
import { message } from 'antd'
import fetch from 'dva/fetch'

class auth {
  login (account,verifyCode, cb) {
    cb = arguments[arguments.length - 1]
  
    serverLogin(account,verifyCode, (res) => {
      if (res.authenticated) {
        localStorage.accessToken = res.accessToken
        localStorage.userName = account
        if (cb) cb(true)
        this.onChange(true)
      } else {
        if (cb) cb(false)
        this.onChange(false)
      }
    })
  }

  loginByPwd (account, password, cb) {
    cb = arguments[arguments.length - 1]

    serverLoginByPwd(account, password, (res) => {
      if (res.authenticated) {
        localStorage.accessToken = res.accessToken
        localStorage.userName = account
        if (cb) cb(true)
        this.onChange(true)
      } else {
        if (cb) cb(false)
        this.onChange(false)
      }
    })
  }

  getToken () {
    return localStorage.accessToken
  }

  getUserName () {
    return localStorage.userName
  }

  logout (cb) {
    delete localStorage.accessToken
    delete localStorage.userName
    delete sessionStorage.clear()
    if (cb) cb()
    history.push('/login')
    this.onChange(false)
  }

  loggedIn () {
    return localStorage.accessToken
  }

  onChange () {

  }
}

function serverLogin (account,verifyCode, cb) {
  fetch(`${origin}/staff/login`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    mode: 'cors',
    body: JSON.stringify({
      account,
      verifyCode,
    })
  }).then(res => res.json()).then(json => {
    if (json.code === 0) {
      cb({
        authenticated: true,
        accessToken: json.data.accessToken,
        userName: json.data.userName
      })
    } else {
      cb({
        authenticated: false
      })
      message.error(json.msg)
    }
  })
}

function serverLoginByPwd (account, password, cb) {
  fetch(`${origin}/staff/login`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    mode: 'cors',
    body: JSON.stringify({
      account,
      password,
    })
  }).then(res => res.json()).then(json => {
    if (json.code === 0) {
      cb({
        authenticated: true,
        accessToken: json.data.accessToken,
        userName: json.data.userName
      })
    } else {
      cb({
        authenticated: false
      })
      message.error(json.msg)
    }
  })
}

export default new auth()



/** WEBPACK FOOTER **
 ** ./src/services/auth.js
 **/